export default {
  routes: [
    {
      name: 'trainingapps',
      path: '/directory/trainingapp',
      component: () => import('./views/TheTrainingApps.vue'),

    },

    {
      name: 'trainingapp',
      path: '/directory/trainingapp/:uuid',
      component: () => import('./views/TheTrainingApp.vue'),
    },
  ]
}
